import { api } from "@/lib/api";
import type { PageResponse, VisitDto, VisitSummaryEntry } from "@/types/api";

export interface VisitFilters {
    domainId?: number | null;
    pageVersionId?: number | null;
    createdFrom?: string | null;
    createdTo?: string | null;
    page?: number;
    size?: number;
    /** Filter by attributed advertiser. `-1` means "IS NULL" (unassigned). */
    advertiserId?: number | null;
    /** Filter by attributed affiliate. `-1` means "IS NULL" (unassigned). */
    affiliateId?: number | null;
}

function toParams(filters: VisitFilters): Record<string, string | number> {
    const params: Record<string, string | number> = {};
    if (filters.domainId != null) params.domainId = filters.domainId;
    if (filters.pageVersionId != null) params.pageVersionId = filters.pageVersionId;
    if (filters.createdFrom) params.createdFrom = filters.createdFrom;
    if (filters.createdTo) params.createdTo = filters.createdTo;
    if (filters.page != null) params.page = filters.page;
    if (filters.size != null) params.size = filters.size;
    if (filters.advertiserId != null) params.advertiserId = filters.advertiserId;
    if (filters.affiliateId != null) params.affiliateId = filters.affiliateId;
    return params;
}

export async function searchVisits(filters: VisitFilters): Promise<PageResponse<VisitDto>> {
    const { data } = await api.get<PageResponse<VisitDto>>("/admin/visits", { params: toParams(filters) });
    return data;
}

export async function visitSummary(
    createdFrom?: string,
    createdTo?: string
): Promise<VisitSummaryEntry[]> {
    const { data } = await api.get<VisitSummaryEntry[]>("/admin/visits/summary", {
        params: { createdFrom, createdTo },
    });
    return data;
}
